/* TONERY — Managed Print Services · shared behaviours (guarded, delegated) */
(function(){
  if(window.__tmpsInit) return; window.__tmpsInit = true;

  /* reveal-on-scroll */
  function initReveal(scope){
    var els = (scope||document).querySelectorAll('.tmps .reveal:not(.in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold:.1 });
    els.forEach(function(e){ io.observe(e); });
  }
  initReveal(document);
  document.addEventListener('shopify:section:load', function(e){ initReveal(e.target); });

  /* brands show more / less */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-tmps-brands-toggle]'); if(!t) return;
    var root = t.closest('[data-tmps-brands]'); if(!root) return;
    var open = root.classList.toggle('is-open');
    var vis = parseInt(root.getAttribute('data-visible')||'12',10);
    root.querySelectorAll('.btile').forEach(function(tile,i){ if(i>=vis) tile.classList.toggle('hidden', !open); });
    t.textContent = open ? (t.getAttribute('data-less')||'Show fewer') : (t.getAttribute('data-more')||'Show more');
  });

  /* info carousel arrows */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-tmps-car]'); if(!b) return;
    var wrap = b.closest('[data-tmps-carousel]'); if(!wrap) return;
    var track = wrap.querySelector('[data-tmps-track]'); var card = track.querySelector('.icard');
    if(!card) return;
    var step = card.offsetWidth + 22;
    track.scrollBy({ left: parseInt(b.getAttribute('data-tmps-car'),10) * step, behavior:'smooth' });
  });

  /* plan quote popup (opens the enquiry section / modal by id) */
  document.addEventListener('click', function(e){
    var o = e.target.closest('[data-tmps-plan-open]'); if(!o) return;
    var sel = o.getAttribute('data-tmps-target');
    var modal = sel ? document.querySelector(sel) : null;
    if(!modal){ return; } /* if no modal target, let the link behave normally */
    e.preventDefault();
    var name = o.getAttribute('data-plan-name')||'';
    var field = modal.querySelector('[data-tmps-plan-field]');
    var label = modal.querySelector('[data-tmps-plan-chosen]');
    if(field) field.value = name;
    if(label){ if(name){ label.hidden=false; label.innerHTML='Selected plan: <b>'+name+'</b>'; } else { label.hidden=true; } }
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var f = modal.querySelector('input,textarea,button'); if(f) setTimeout(function(){f.focus();},60);
  });
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-tmps-plan-close]')){
      var m = e.target.closest('.tmps-modal'); if(!m) return;
      m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.body.style.overflow='';
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key==='Escape'){ var m=document.querySelector('.tmps-modal.is-open'); if(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }
  });
})();
